import { useEffect, useState } from 'react'

const HydrationZustand = ({
	children,
	fallback = null,
}: {
	children: React.ReactNode
	fallback?: React.ReactNode
}) => {
	const [isHydrated, setIsHydrated] = useState(false)

	useEffect(() => {
		setIsHydrated(true)
	}, [])

	return <>{isHydrated ? <div>{children}</div> : fallback}</>
}

export default HydrationZustand
